module.exports = __webpack_public_path__ + "static/media/top-slide-1.22a02bc6.jpeg";